export const PHONE_PATTERN = '[+0-9()\\s\\-]*';
